import axios, { CancelTokenSource } from 'axios';
import {
	IStudyPlanEntityAttributes,
	PlanSelectionEntity,
	RequiringStudyPlanStudyPlanRequirement,
} from 'Models/Entities';
import { SERVER_URL } from 'Constants';
import { IGeneratedPlan } from 'Queries/Hooks/StudyPlan/types';
import { AbortSignals } from 'Hooks/useAbortSignals';

export const updatePlanProgramStructure = async (
	studyPlanId: string,
	programStructureId: string,
) => {
	console.warn('updatePlanProgramStructure needs abort request signals');
	const data = await axios
		.post<RequiringStudyPlanStudyPlanRequirement[]>(
			`${SERVER_URL}/api/entity/StudyPlanEntity/select-structure`,
			{
				studyPlanId,
				programStructureId,
			},
		);

	return data;
};

export const selectPlanRequirement = async (
	studyPlanId: string,
	componentId: string,
	requirementId: string,
) => {
	console.warn('selectPlanRequirement needs abort request signals');
	const data = await axios
		.post<RequiringStudyPlanStudyPlanRequirement[]>(
			`${SERVER_URL}/api/entity/StudyPlanEntity/select-requirement`,
			{
				studyPlanId,
				componentId,
				requirementId,
			},
		);

	return data;
};

export const savePlanSelections = async (
	cancelToken: CancelTokenSource | undefined,
	studyPlanId: string,
	programStructureId?: string,
	selectedRequirements?: string[],
	newPlanSelections?: PlanSelectionEntity[],
) => {
	console.warn('savePlanSelections needs abort request signals');
	return axios
		.post<{ studyPlan: IStudyPlanEntityAttributes }>(
			`${SERVER_URL}/api/entity/StudyPlanEntity/select-courses`,
			{
				studyPlanId,
				programStructureId,
				selectedRequirements,
				newPlanSelections,
			},
			{
				cancelToken: cancelToken?.token,
			},
		);
};

export const validateCourseSelection = async (
	studyPlanId: string,
	plannedCourseOfferingIds: string[],
	completedCourseIds: string[],
) => {
	console.warn('validateCourseSelection needs abort request signals');
	return axios.post<IGeneratedPlan>(
		`${SERVER_URL}/api/entity/StudyPlanEntity/validate`,
		{
			studyPlanId,
			plannedCourseOfferingIds,
			completedCourseIds,
		},
	);
};

export const generatePlan = async (
	abortSignals: AbortSignals,
	studyPlanId: string,
	studyLoadConfig?: number[][][],
) => (
	axios
		.post<IGeneratedPlan>(
			`${SERVER_URL}/api/entity/StudyPlanEntity/generate`,
			{ studyPlanId, studyLoadConfig },
			{
				cancelToken: abortSignals.axiosCancelToken.token,
			},
		)
);

export const activateStudyPlan = async (studyPlanId: string) => (
	axios.put(`${SERVER_URL}/api/entity/StudyPlanEntity/activate/${studyPlanId}`)
);

export const duplicateStudyPlan = async (studyPlanId: string, name:string) => {
	return axios.post(`${SERVER_URL}/api/entity/StudyPlanEntity/duplicate`, {
		studyPlanId,
		name,
	}).then(data => data);
};
